import { render, staticRenderFns } from "./Multiline.vue?vue&type=template&id=2b061760&scoped=true"
import script from "./Multiline.vue?vue&type=script&lang=js"
export * from "./Multiline.vue?vue&type=script&lang=js"
import style0 from "./Multiline.vue?vue&type=style&index=0&id=2b061760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b061760",
  null
  
)

export default component.exports